export default __webpack_public_path__ + "static/media/digiTimeout.616a387b.png";